import './loading.scss'

// se experimentó con Lottie y se desidió usar una css puro
export const Loading = ({ small }) => {
	return (
		<div data-testid='loading__spin' className={`a-loading ${small ? 'small' : ''}`}>
			<div className='a-loading__spin'>
				<span className='spin1' />
				<span className='spin2' />
				<span className='spin3' />
				<span className='spin4' />
				<span className='spin5' />
			</div>
		</div>
	)
}

export default Loading
